/**
 * Under an audit row's action, when the change was not made by one of the tenant's own
 * people: FreshOrder support signed in to the org (super-admin impersonation,
 * `metadata.actor === 'super_admin'` — the row's userId is then the admin the session
 * borrowed), or Clyde acting on a text (`metadata.actor === 'clyde'`, no userId).
 */
export function SupportActorMark({ actor }: { actor?: string }) {
  if (actor === "clyde") {
    return (
      <div className="mt-1 text-xs text-muted-foreground" data-testid="text-actor-clyde">
        by Clyde
      </div>
    );
  }
  if (actor !== "super_admin") return null;
  return (
    <div className="mt-1 text-xs text-muted-foreground" data-testid="text-actor-support">
      by FreshOrder support
    </div>
  );
}
